import { createAction, props } from '@ngrx/store';

export const getPartners = createAction('[Partner] Get Partners');

export const getPartnersSuccess = createAction('[Partner] Get Partners Success', props<{ data: any }>());

export const getPartnersFailure = createAction('[Partner] Get Partners Failure', props<{ error: any }>());
